/* import __COLOCATED_TEMPLATE__ from './status.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { KnowledgeHubContentStatus } from 'embercom/lib/knowledge-hub/constants';
import { inject as service } from '@ember/service';
import type HelpCenterSite from 'embercom/models/help-center-site';
import KnowledgeHubContentWrapper from 'embercom/models/content-service/knowledge-hub-content-wrapper';
import ContentFragment from 'embercom/models/content-service/content-fragment';
import { State } from 'embercom/models/data/matching-system/matching-constants';

interface Args {
  tableRow: KnowledgeHubContentWrapper | ContentFragment;
}

const NUMBER_OF_HELP_CENTERS_TO_DISPLAY = 2;

export default class Status extends Component<Args> {
  @service declare helpCenterService: $TSFixMe;

  get statesList() {
    return [this.args.tableRow.state as unknown as KnowledgeHubContentStatus];
  }

  get stateWhenUsed() {
    return KnowledgeHubContentStatus.LIVE;
  }

  get inHelpCenter(): boolean {
    return this.helpCenterIds.length > 0;
  }

  get hasStatuses(): boolean {
    let states = this.statesList;
    return states && states.length > 0 && states.firstObject !== undefined;
  }

  get helpCenterSites(): HelpCenterSite[] {
    return this.helpCenterService.allSites;
  }

  get helpCenterIds(): number[] {
    if (this.args.tableRow instanceof KnowledgeHubContentWrapper) {
      return this.args.tableRow.contents.firstObject!.contentData?.help_center_ids ?? [];
    }
    if (this.args.tableRow instanceof ContentFragment) {
      return this.args.tableRow.contentData?.help_center_ids ?? [];
    }
    return [];
  }

  get helpCenterNames(): string[] {
    let names = this.helpCenterIds.map(
      (id: number) =>
        this.helpCenterSites.find((helpCenter: HelpCenterSite) => helpCenter.id === String(id))
          ?.name ?? undefined,
    );
    return names.compact();
  }

  get appHasMultipleHelpCenters(): boolean {
    return this.helpCenterSites.length > 1;
  }

  get helpCenterNamesToDisplay(): string {
    if (this.args.tableRow.state !== State.Live) {
      return '';
    }
    return this.helpCenterNames.slice(0, NUMBER_OF_HELP_CENTERS_TO_DISPLAY).join(', ');
  }

  get moreCount(): number {
    return this.helpCenterIds.length - NUMBER_OF_HELP_CENTERS_TO_DISPLAY;
  }

  get moreHelpCenterNames(): string[] {
    return this.helpCenterNames.slice(
      NUMBER_OF_HELP_CENTERS_TO_DISPLAY,
      this.helpCenterNames.length,
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Table::Cells::Status': typeof Status;
    'knowledge-hub/filterable-list/table/cells/status': typeof Status;
  }
}
